import { getTotalStopCount } from 'lib/flights/flightUtils'
import { isResolvedFlightJourneyId } from './flightJourneyId'

/**
 * Renders the per-journey context block sent to the assistant when a flight is
 * added to the trip. Shared by the flight search drawer and the chat flight
 * recommendation cards so the context format stays single-sourced.
 *
 * `fareFamily` is the fare the traveller picked in the "Select a fare" modal
 * before the flight was sent, when the journey offered a choice.
 */
export function buildFlightContext(journey: App.JourneyV2, fareFamily?: App.FlightFareFamily): string {
  const jFlights = journey.flightGroup.flights
  const firstFlight = jFlights[0]
  const lastFlight = jFlights[jFlights.length - 1]
  const duration = journey.flightGroup.totalFlightDuration
  const lines = [
    `Carrier: ${journey.carrierName}`,
    `Flight: ${jFlights.map(f => f.flightNumber).filter(Boolean).join(' / ')}`,
    `From: ${firstFlight.departureAirport} (${firstFlight.departureAirportName})`,
    `To: ${lastFlight.arrivalAirport} (${lastFlight.arrivalAirportName})`,
    `Departure: ${firstFlight.departureDateTime}`,
    `Arrival: ${lastFlight.arrivalDateTime}`,
    `Duration: ${duration.hours}h ${duration.minutes}m`,
    `Stops: ${getTotalStopCount(jFlights)}`,
    `Price: ${journey.currencyCode} ${journey.price.adult.totalFare}`,
    `Fare type: ${journey.fareType}`,
    `Carrier logo: ${journey.carrierBrandMark ?? journey.carrierLogo}`,
  ]
  if (journey.regularPrice?.all?.totalFare !== undefined) lines.push(`Regular price: ${journey.currencyCode} ${journey.regularPrice.all.totalFare}`)
  if (journey.regularPrice?.adult?.totalFare !== undefined) lines.push(`Regular price per person: ${journey.currencyCode} ${journey.regularPrice.adult.totalFare}`)
  if (journey.bookingInfo?.isLuxPlusFare !== undefined) lines.push(`LuxPlus fare: ${journey.bookingInfo.isLuxPlusFare}`)
  if (journey.bookingInfo?.journeyKey) lines.push(`Journey Key: ${journey.bookingInfo.journeyKey}`)
  if (isResolvedFlightJourneyId(journey.id, journey.bookingInfo?.journeyKey)) lines.push(`Journey ID: ${journey.id}`)
  if (journey.bookingInfo?.providerSearchId) lines.push(`Search ID: ${journey.bookingInfo.providerSearchId}`)
  if (fareFamily) {
    lines.push(`Selected fare: ${fareFamily.fareFamily.name}`)
    lines.push(`Selected fare cabin: ${fareFamily.cabin}`)
    lines.push(`Selected fare ID: ${fareFamily.id}`)
    lines.push(`Selected fare total: ${journey.currencyCode} ${fareFamily.cost.all}`)
  }
  return lines.join('\n')
}
